import {
  RESET_CHANNELS,
  RESET_CHANNEL,
  RESET_ERROR,
  GET_CHANNELS,
  SET_CHANNELS,
  API_ERROR,
  GET_CHANNEL,
  SET_CHANNEL,
  CREATE_CHANNEL,
  CREATE_CHANNEL_SUCCESS,
  EDIT_CHANNEL,
  EDIT_CHANNEL_SUCCESS,
  DELETE_CHANNEL,
  DELETE_CHANNEL_SUCCESS,
} from "./actionTypes";

export const resetChannels = () => {
  return {
    type: RESET_CHANNELS,
    payload: {},
  };
};

export const resetChannel = () => {
  return {
    type: RESET_CHANNEL,
    payload: {},
  };
};

export const resetError = () => {
  return {
    type: RESET_ERROR,
    payload: {},
  };
};

export const getChannels = (page, qnt, name) => {
  return {
    type: GET_CHANNELS,
    payload: { page, qnt, name },
  };
};

export const setChannels = (data, qtdDefault) => {
  const maxPage = Math.ceil(data.total / qtdDefault);
  var paging = Array.from({ length: maxPage }, (v, k) => k + 1);

  return {
    type: SET_CHANNELS,
    payload: { ...data, paging },
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const createChannel = (newChannelValues) => {
  return {
    type: CREATE_CHANNEL,
    payload: { newChannelValues },
  };
};
export const createChannelSuccess = (message) => {
  return {
    type: CREATE_CHANNEL_SUCCESS,
    payload: { message },
  };
};

export const getChannel = (idChannel, isForm) => {
  return {
    type: GET_CHANNEL,
    payload: { idChannel, isForm },
  };
};
export const setChannel = (data) => {
  return {
    type: SET_CHANNEL,
    payload: { data },
  };
};

export const editChannel = (idChannel, newChannelValues) => {
  return {
    type: EDIT_CHANNEL,
    payload: { idChannel, newChannelValues },
  };
};
export const editChannelSuccess = (message) => {
  return {
    type: EDIT_CHANNEL_SUCCESS,
    payload: { message },
  };
};

export const deleteChannel = (idChannel) => {
  return {
    type: DELETE_CHANNEL,
    payload: { idChannel },
  };
};
export const deleteChannelSuccess = (message) => {
  return {
    type: DELETE_CHANNEL_SUCCESS,
    payload: { message },
  };
};
